import type { BrowserOptions } from '@sentry/browser'
import { init as sentryInit } from '@sentry/react'

import config from '@app/config'

import type { ErrorReportController } from '@app/services/ErrorReportController'

import { createEventProcessor } from './eventProcessor'
import { sharedSentryOptions } from './sentryOptions'

/** `getLastActions` hands every report the types of the store's last actions; see `ActionTrail`. */
export function init({
  requestId,
  errorReportController,
  getLastActions,
}: {
  requestId: string
  errorReportController: ErrorReportController
  getLastActions?: () => readonly string[]
}) {
  const options: BrowserOptions = {
    ...sharedSentryOptions,
    dsn: 'https://744c1f9bf3b6475183d42cb58533b699@sentry.io/144703',
    release: GIT_SHA,
    enabled: config.sentry,
    allowUrls: BUILD_MODE === 'production' ? [/https?:\/\/(cdn\.)?(staging\.)?kidsout\.ru\/assets/] : undefined,
    environment: API_MODE,
    // Console breadcrumbs stay off; since Sentry 11 they come from an integration of their own.
    integrations: defaultIntegrations => defaultIntegrations.filter(integration => integration.name !== 'Console'),
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,
    tracesSampleRate: BUILD_MODE !== 'production' ? 1 : 0.02,
    initialScope(scope) {
      scope.setTag('transaction_id', requestId)
      if (getLastActions) scope.addEventProcessor(event => ({ ...event, extra: { ...event.extra, redux_last_actions: getLastActions() } }))
      return scope
    },
    beforeSend: createEventProcessor({ dropFrameless: true, errorReportController }),
  }

  sentryInit(options)
}
